@if (version) {
  <div class="detail-form">
    @if (showPersonendaten(master.hasAuskunftssperre)) {
      <div>
        <cap-persongb-detail-title
          [auskunftsperre]="master.hasAuskunftssperre"
          [personGbMasterId]="master.id"
          [personGbVersion]="version"
          [showTitlebutton]="showTitlebutton">
        </cap-persongb-detail-title>
        <cap-rubrik [id]="'personalienRubrik'" [isClosable]="false" [isOpen]="true" class="m-0">
          <ng-container title>
            <h2 class="mb-0">{{ "Personalien" | translate }}</h2>
          </ng-container>
          @switch (version.art) {
            @case ("NATUERLICHE_PERSON") {
              <cap-persongb-natuerliche-person [master]="master" [version]="version"></cap-persongb-natuerliche-person>
            }
            @case ("JURISTISCHE_PERSON") {
              @if (!master.isAuslaendischeRechtsform.valueOf()) {
                <cap-persongb-schweiz-juristische-person [master]="master" [version]="version"></cap-persongb-schweiz-juristische-person>
              }
              @if (master.isAuslaendischeRechtsform.valueOf()) {
                <cap-persongb-auslaendischerechtsform [master]="master" [version]="version"></cap-persongb-auslaendischerechtsform>
              }
            }
            @case ("OEFFENTLICH_RECHTLICHE_PERSON") {
              <cap-persongb-oeffentl-rechtl-koerperschaft
                [master]="master"
                [version]="version"></cap-persongb-oeffentl-rechtl-koerperschaft>
            }
            @case ("GEMEINSCHAFT") {
              <cap-persongb-gemeinschaft [master]="master" [version]="version"></cap-persongb-gemeinschaft>
            }
          }
        </cap-rubrik>
        @if (master?.personstammMasterId?.id) {
          <cap-rubrik [id]="'stammpersonRubrik'" [isClosable]="false" [isOpen]="true" class="m-0">
            <ng-container title>
              <h2 class="mb-0">{{ "Stammperson" | translate }}</h2>
            </ng-container>
            <cap-personstamm-view [historyMode]="historyMode" [personStammMasterId]="master.personstammMasterId"></cap-personstamm-view>
          </cap-rubrik>
        }
        <cap-rubrik>
          <ng-container title>
            <h2 class="mb-0">{{ "Rolle" | translate }}</h2>
          </ng-container>
          <cap-persongb-rolle [master]="master" [version]="version"></cap-persongb-rolle>
        </cap-rubrik>
      </div>
    } @else {
      <div>
        <span style="font-style: italic">{{ "stammperson-auskunftsperre" | translate }}</span>
      </div>
    }
  </div>
} @else {
  <cap-spinner-small [withBreadcrumb]="true"></cap-spinner-small>
}

<ng-template #keine><span>{{"Keine" | translate}}</span></ng-template>
